export const SAT_UATPROJ_HOSTNAME = "sat-uatproj.allianz.com.my";
export const UATPROJ_CONTEXT_PATH_PREFIX = "uatproj-";
const SAT_MOTOR_CONTEXT_PATH = "/sat-motor";

export function getRuntimeHostname(): string {
  return globalThis.location?.hostname?.toLowerCase?.() ?? "";
}

export function isSatUatProjHostname(
  hostname: string = getRuntimeHostname(),
): boolean {
  return hostname.includes(SAT_UATPROJ_HOSTNAME);
}

// UATPROJ context path has a prefix, so we need to append it.
// sat-motor does not need the prefix
export function applyUatProjContextPathPrefix(
  path: string,
  hostname: string = getRuntimeHostname(),
): string {
  if (
    !path ||
    !path.startsWith("/") ||
    path.startsWith(SAT_MOTOR_CONTEXT_PATH) ||
    !isSatUatProjHostname(hostname)
  ) {
    return path;
  }

  const contextPath = path.slice(1);

  if (contextPath.startsWith(UATPROJ_CONTEXT_PATH_PREFIX)) {
    return path;
  }

  return `/${UATPROJ_CONTEXT_PATH_PREFIX}${contextPath}`;
}
